import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { GenericSvg } from "../../../assets/svgs/GenericSVG";
import { CustomButton } from "../../../core/components/buttons/CustomButton";
import { Body } from "../../../core/styles/stringStyles";
import { useStyles } from "../../../core/styles/theme";
import { SideBarNavItemType } from "../utils/useHandleSideBarNavItems";

type Props = SideBarNavItemType & { active: boolean; onClick?: () => void };

export const SideBarNavItem = (props: Props) => {
  const theme = useStyles();
  const { t } = useTranslation();

  return (
    <Container $isActive={props.active} onClick={props.onClick}>
      <GenericSvg
        name={props.iconName}
        width={24}
        height={24}
        primaryColor={props.active ? theme.colors.white : theme.colors.white}
      />
      <Label>{t(props.label)}</Label>
    </Container>
  );
};

const Container = styled(CustomButton)<{ $isActive: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  padding: 5px 10px;
  opacity: ${(props) => (props.$isActive ? 1 : 0.6)};
`;

const Label = styled(Body)`
  color: ${({ theme }) => theme.colors.white};
`;
